module.exports = __webpack_public_path__ + "static/media/icon-walkin.deb29040.svg";